import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend"; // Enables loading translations from files
import LanguageDetector from "i18next-browser-languagedetector"; // Detects user language

i18n
  .use(HttpApi) // Load translations from JSON files
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "ar"], // Available languages
    fallbackLng: "en", // Default language if translation is missing
    debug: true, // Enable debugging
    interpolation: {
      escapeValue: false, // Not needed for React
    },
    backend: {
        loadPath: "/locales/{{lng}}/messages.json", // Path to translation files
    },
    react: {
      useSuspense: false, // Disable Suspense to prevent UI blocking
    },
  });

export default i18n;
